export default {
  OK: "确定",
  CANCEL: "取消",
  CLOSE: "关闭",
  inputHere: "正在输入中...",
  send: "发送",
  finishSession: "结束会话",
  createSession: "正在创建会话，请耐心等待片刻",
  withDrawned: "已撤回",
  serviceSys: "客服系统",
  haveread: "已读",
  unread: "未读",
  noMoreHistoryLog: "无更多历史记录",
  confirmRecall: "确定撤回当前消息？",
  expression: "表情",
  sendfile: "发送文件",
  satisfyEvaluation: "满意度评价",
  message: "留言",
  inputContent: "请输入内容",
  selectSkill: "请选择您要转接的人工客服技能组",
  clickToSelectSkill: "点击技能组转接人工客服",
  clickDownload: "点击下载文件",
  doseNotsupportVideo: "您的浏览器不支持 video 标签。",
  peakPeriod: "亲，当前是咨询高峰期",
  refreshQueue: "点此刷新排队状态",
  isSolved: "本次问题是否解决呢？",
  solved: "解决",
  unsolved: "未解决",
  dissatisfyReason: "请选择不满意的原因：",
  commentService: "为了更好的为您服务，请您为本次服务做个评价~",
  commentservice: "请您对本次服务做出评价",
  uploadFile: "上传文件",
  verySatisfied: "非常满意",
  satisfied: "满意",
  general: "一般",
  notSatisfied: "不满意",
  veryDissatisfied: "非常不满意",
  uploading: "上传中...",
  icon: "图标",
  submitFeed: "提交反馈",
  loading: "正在加载中...",
  msgHaveWithDrawned: "消息已撤回",
  afterSale: "请帮我售后以下商品",
  loadMore: "加载更多",
  talkHere: "上次聊到这里",
  holdToSpeak: "按住 说话",
  sendImg: "发送图片",
  takeAVideo: "拍视频",
  feedback: "意见反馈",
  questionIsSolve: "本次问题是否解决呢？",
  pleaseEnter: "请输入",
  pleaseSelect: "请选择",
  enterCorrectPhone: "请输入正确的电话号码格式",
  enterCorrectEmail: "请输入正确的邮箱格式",
  phoneFormat: "电话号码格式",
  emailFormat: "邮箱格式",
  enterNum: "请输入数字",
  number: "数字",
  enterEnglish: "请输入英文",
  english: "英文",
  enterChinese: "请输入中文",
  chinese: "中文",
  enterSpecial: "请输入特殊字符",
  special: "特殊字符",
  onlyEnter: "只能输入",
  lengthNotExceed: "长度不得超过",
  reset: "重置",
  resetNbsp: "重置",
  submit: "提交",
  submitNbsp: "提交",
  successful: "操作成功",
  fail: "操作失败",
  feedSuccessful: "留言反馈成功，请点击左上角关闭页面",
  messageTitle: "留言标题",
  exitQueue: "是否确定退出排队?",
  exitSuccess: "退出排队成功",
  exitFailed: "退出排队失败",
  meassageHasBeenRevoked: '消息已撤回',
  messageDetails: '消息详情',
  messageSendTime: '消息时间',
  img: '图片',
  video: '视频',
  voice: '语音'
};
